// =======================================
// DATA TYPES
// =======================================

export interface ContactOption {
  id: number;
  first_name: string;
  last_name: string;
  email: string | null;
  phone: string | null;
  client_id: number;
  company_name: string;
}

export interface SearchableContactDropdownProps {
  value?: string | number | null;
  onChange: (contactId: string | number | null, contact?: ContactOption | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  allowNone?: boolean;
  noneLabel?: string;
  required?: boolean;
  clientId?: number | null;
}

// =======================================
// CONSTANTS
// =======================================

export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_DEBOUNCE_DELAY = 300;
export const MAX_SEARCH_RESULTS = 50;
